import React, { StrictMode, Fragment } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { store } from './store';
import { queryClient } from './lib/react-query';
import App from './App.tsx';
import './index.css';

const isDev = (import.meta as any)?.env?.DEV;
const Wrapper = isDev ? Fragment : StrictMode;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Wrapper>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </Wrapper>,
);